import conversationResponseShape from 'owa-service/lib/factory/conversationResponseShape';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import propertyUri from 'owa-service/lib/factory/propertyUri';
export var FindConversationShapeName = 'ReactConversationListView';
var FindConversationSentItemsShapeName = 'ReactConversationSentItemsListView';
/**
 * Gets find conversation response shape.
 * @returns The ConversationResponseShape
 */
export function getFindConversationResponseShape(folderId) {
    // If we are in the scheduled folder, additionally request ReturnTime
    if (folderId && folderIdToName(folderId) == 'scheduled') {
        return conversationResponseShape({
            BaseShape: 'IdOnly',
            AdditionalProperties: [propertyUri({ FieldURI: 'ConversationReturnTime' })],
        });
    }
    return conversationResponseShape({ BaseShape: 'IdOnly' });
}
/**
 * Gets find conversation shape name based on the folder. The ReactConversationSentItemsListView
 * shape gives back recipients whereas the ReactConversationListView gives back senders.
 * @param folderId the folder for which we are going to do findConversation
 * @returns the shape name
 */
export function getFindConversationShape(folderId) {
    return folderIdToName(folderId) == 'sentitems' || folderIdToName(folderId) == 'drafts'
        ? FindConversationSentItemsShapeName
        : FindConversationShapeName;
}
//# sourceMappingURL=findConversationShapeUtil.js.map